import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cajaId: null,
  isOpen: false,
};

export const cajaSlice = createSlice({
  name: 'caja',
  initialState,
  reducers: {
    setCajaStatus: (state, action) => {
      state.cajaId = action.payload.cajaId;
      state.isOpen = action.payload.isOpen;
    },
    resetCajaStatus: (state) => {
      state.cajaId = null;
      state.isOpen = false;
    },
  },
});

export const { setCajaStatus, resetCajaStatus } = cajaSlice.actions;
export default cajaSlice.reducer;